import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { PlanResponse } from '@/modules/plan/plan.types';

export const QUERY_KEY = 'PLAN_BY_ID';
export const usePlanByIdQuery = (
  id?: string,
  successCallback?: (plan: PlanResponse) => void,
  enabled = true
) => {
  const { error, data, isSuccess, isError, isFetching, isLoading } = useQuery(
    [QUERY_KEY, id],
    // TODO: the DTO type is missing
    id ? () => api.get<PlanResponse>(API_URL.PLANS_BY_PLAN_ID(id)) : () => null,
    {
      enabled: enabled && !!id,
      onSuccess: (response) => {
        if (successCallback && response) {
          successCallback(response.data);
        }
        return response;
      },
      cacheTime: 10,
      refetchOnMount: false,
    }
  );

  const planStatus = useMemo(() => {
    if (data?.data?.plan_status) {
      return data.data.plan_status;
    }
    return undefined;
  }, [data?.data?.plan_status]);

  return {
    data: data?.data,
    planStatus,
    error,
    isError,
    isFetching,
    isLoading,
    isSuccess,
  };
};

export default usePlanByIdQuery;
